import { render } from "./DaftarAduan.vue?vue&type=template&id=4015a099"
import script from "./DaftarAduan.vue?vue&type=script&lang=js"
export * from "./DaftarAduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__